<div class="flex flex-col filter-modal-container relative">
  <!-- header -->
  <div class="p-base pb-lg">
    <!-- Close Btn -->
    <div class="hidden md:flex absolute cursor-pointer top-base right-lg text-txt">
      <svg-icon key="close" class="!text-2xs" (click)="dialogRef.close()"></svg-icon>
    </div>

    <lla-button
      class="md:hidden absolute top-base right-lg"
      size="medium-shrink"
      variant="ghost"
      (click)="resetForm()"
    >
      Clear all
    </lla-button>

    <!-- Title -->
    <div class="text-lg leading-lg text-txt font-semibold">Filters</div>
  </div>

  <!-- Form -->
  <form [formGroup]="form" class="px-base flex-1 overflow-y-auto flex flex-col beautyScroll">
    <lla-shops-selector
      controlName="locationIds"
      searchInputId="searchInputId"
      [onlyUserShops]="!data.showAllShops"
      [maxSelectable]="data.maxSelectableShops"
      [minSelectable]="data.minSelectableShops"
      [showLimitMessage]="!!data.showLimitMessage"
      [hideStates]="!!data.hideStates"
    ></lla-shops-selector>
  </form>

  <!-- Footer -->
  <div class="mx-base py-sm flex flex-col md:flex-row md:items-center md:justify-between gap-xs">
    <lla-button
      class="hidden md:block"
      size="medium"
      variant="ghost"
      icon="close-circle"
      extraBtnClass="!pl-xs"
      (click)="resetForm()"
    >
      Clear all
    </lla-button>
    <lla-button size="medium" [disabled]="form.invalid" (click)="onSubmit()">
      Show results
      {{ this.form.value?.locationIds?.length ? '(' + this.form.value.locationIds.length + ')' : '' }}
    </lla-button>

    <lla-button
      class="md:hidden"
      extraBtnClass="!text-primary"
      variant="ghost"
      size="medium"
      type="button"
      (click)="dialogRef.close()"
    >
      Cancel
    </lla-button>
  </div>
</div>
